/**
 * naraigoto.js — 習い事カードのスクロールスナップ型スライダー。
 * JS が無効でも横スクロールで全講座を確認できる。
 */
(function () {
  'use strict';

  function initLessonSlider(root) {
    var viewport = root.querySelector('.p-lesson-slider__viewport');
    var track = root.querySelector('.p-lesson-slider__track');
    var cards = Array.from(root.querySelectorAll('.p-lesson-card'));
    var controls = root.querySelector('.p-lesson-slider__controls');
    var prev = root.querySelector('.p-lesson-slider__arrow--prev');
    var next = root.querySelector('.p-lesson-slider__arrow--next');
    var currentLabel = root.querySelector('.p-lesson-slider__current');
    var progress = root.querySelector('.p-lesson-slider__progress i');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var current = 0;
    var frame = 0;

    if (!viewport || !track || cards.length === 0 || !controls || !prev || !next || !currentLabel) return;

    controls.hidden = false;

    function itemLeft(index) {
      return cards[index].offsetLeft - track.offsetLeft;
    }

    function update(index) {
      current = Math.max(0, Math.min(cards.length - 1, index));
      currentLabel.textContent = String(current + 1).padStart(2, '0');
      if (progress) progress.style.width = (((current + 1) / cards.length) * 100) + '%';
      prev.disabled = current === 0;
      next.disabled = current === cards.length - 1;
    }

    function goTo(index) {
      var target = Math.max(0, Math.min(cards.length - 1, index));
      viewport.scrollTo({
        left: itemLeft(target),
        behavior: reduced.matches ? 'auto' : 'smooth'
      });
      update(target);
    }

    prev.addEventListener('click', function () { goTo(current - 1); });
    next.addEventListener('click', function () { goTo(current + 1); });
    viewport.addEventListener('scroll', function () {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(function () {
        var closest = 0;
        var distance = Infinity;
        cards.forEach(function (_card, index) {
          var candidate = Math.abs(viewport.scrollLeft - itemLeft(index));
          if (candidate < distance) {
            distance = candidate;
            closest = index;
          }
        });
        update(closest);
      });
    }, { passive: true });

    window.addEventListener('resize', function () { goTo(current); });
    update(0);
  }

  function init() {
    document.querySelectorAll('.js-lesson-slider').forEach(initLessonSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
